export const productData = {
  categories: [
    {
      id: 'stickers',
      name: 'Stickers',
      icon: '🏷️',
      image: '/images/categories/Stickers/Stickers.png',
      description: 'High-quality custom stickers',
      subcategories: [
        {
          id: 'custom-stickers',
          name: 'Custom Stickers',
          image: '/images/step2/Stickers/Custom_Stickers.png',
          materials: [
            { id: 'white-vinyl-removable-semi', name: 'White Vinyl Removable Semi-Gloss' },
            { id: 'white-vinyl-permanent-semi', name: 'White Vinyl Permanent Semi-Gloss' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 20000,
          unitLabel: 'Sticker'
        },
        {
          id: 'die-cut-singles',
          name: 'Die-Cut Sticker Singles',
          image: '/images/step2/Stickers/Die-Cut_Sticker_Singles.png',
          materials: [
            { id: 'white-vinyl-removable-semi', name: 'White Vinyl Removable Semi-Gloss' },
            { id: 'white-vinyl-permanent-semi', name: 'White Vinyl Permanent Semi-Gloss' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 20000,
          unitLabel: 'Sticker'
        },
        {
          id: 'glitter-stickers',
          name: 'Glitter Stickers',
          image: '/images/step2/Stickers/Glitter_Stickers.png',
          materials: [
            { id: 'permanent-glitter-glossy', name: 'Permanent Glitter Permanent Glossy' }
          ],
          quantityType: 'individual',
          minQty: 25,
          maxQty: 2000,
          unitLabel: 'Sticker'
        },
        {
          id: 'holographic-stickers',
          name: 'Holographic Stickers',
          image: '/images/step2/Stickers/Holographic_Stickers.png',
          materials: [
            { id: 'permanent-holographic-glossy', name: 'Permanent Holographic Permanent Glossy' }
          ],
          quantityType: 'individual',
          minQty: 25,
          maxQty: 2000,
          unitLabel: 'Sticker'
        },
        {
          id: 'permanent-stickers',
          name: 'Permanent Stickers',
          image: '/images/step2/Stickers/Permanent_Stickers.png',
          materials: [
            { id: 'white-vinyl-permanent', name: 'White Vinyl Permanent' }
          ],
          quantityType: 'page',
          minQty: 1,
          maxQty: 100,
          unitLabel: 'Page',
          pageMaker: true
        },
        {
          id: 'transparent-stickers',
          name: 'Transparent Stickers',
          image: '/images/step2/Stickers/Transparent_Stickers.png',
          materials: [
            { id: 'clear-vinyl-removable-semi', name: 'Clear Vinyl Removable Semi-Gloss' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 20000,
          unitLabel: 'Sticker'
        }
      ]
    },
    {
      id: 'labels',
      name: 'Labels',
      icon: '📋',
      image: '/images/categories/Labels/Labels.png',
      description: 'Professional labels for products',
      subcategories: [
        {
          id: 'clear-bopp-rolls',
          name: 'Clear BOPP (Rolls)',
          image: '/images/step2/Labels/Clear_BOPP_Rolls.png',
          materials: [
            { id: 'clear-bopp-permanent-glossy', name: 'Clear BOPP Permanent Glossy' }
          ],
          quantityType: 'roll',
          minQty: 250,
          maxQty: 40000,
          unitLabel: 'Label'
        },
        {
          id: 'white-bopp-rolls',
          name: 'White BOPP (Rolls)',
          image: '/images/step2/Labels/White_BOPP_Rolls.png',
          materials: [
            { id: 'white-bopp-permanent-glossy-laminated', name: 'White BOPP Permanent Glossy (Laminated)' },
            { id: 'white-paper-permanent-glossy-laminated', name: 'White Paper Permanent Glossy (Laminated)' }
          ],
          quantityType: 'roll',
          minQty: 250,
          maxQty: 40000,
          unitLabel: 'Label'
        },
        {
          id: 'gold-silver-foil',
          name: 'Gold & Silver Foil (Rolls)',
          image: '/images/step2/Labels/Gold_and_Silver_Foil_Rolls.png',
          materials: [
            { id: 'colored-foil-permanent-shiny', name: 'Colored Foil Labels Permanent Shiny Color' }
          ],
          quantityType: 'roll',
          minQty: 250,
          maxQty: 40000,
          unitLabel: 'Label'
        },
        {
          id: 'semigloss-paper',
          name: 'SemiGloss Paper (Rolls)',
          image: '/images/step2/Labels/SemiGloss_Paper_Rolls.png',
          materials: [
            { id: 'white-paper-permanent-semi-gloss-eco', name: 'White Paper Permanent Semi-Gloss (Eco-Safe)' }
          ],
          quantityType: 'roll',
          minQty: 250,
          maxQty: 40000,
          unitLabel: 'Label'
        },
        {
          id: 'white-vinyl-pages',
          name: 'White Vinyl (Pages)',
          image: '/images/step2/Labels/White_Vinyl_Pages.png',
          materials: [
            { id: 'white-vinyl-removable-glossy', name: 'White Vinyl Removable Glossy' },
            { id: 'white-vinyl-permanent-glossy', name: 'White Vinyl Permanent Glossy' },
            { id: 'white-vinyl-removable-matte', name: 'White Vinyl Removable Matte' }
          ],
          quantityType: 'page',
          minQty: 1,
          maxQty: 100,
          unitLabel: 'Page',
          pageMaker: true
        },
        {
          id: 'writable-bopp',
          name: 'Writable BOPP (Rolls)',
          image: '/images/step2/Labels/Writable_BOPP_Rolls.png',
          materials: [
            { id: 'white-bopp-permanent-matte-writeable', name: 'White BOPP Permanent Matte (Writeable)' }
          ],
          quantityType: 'roll',
          minQty: 250,
          maxQty: 40000,
          unitLabel: 'Label'
        }
      ]
    },
    {
      id: 'decals',
      name: 'Decals & Clings',
      icon: '🎨',
      image: '/images/categories/Decals_and_Clings/Decals_and_Clings.png',
      description: 'Durable vinyl decals and clings',
      subcategories: [
        {
          id: 'clear-decals',
          name: 'Clear Decals',
          image: '/images/step2/Decals_and_Clings/Clear_Decals.png',
          materials: [
            { id: 'clear-decals-crystal-clear-glossy', name: 'Clear Decals (Crystal Clear) Glossy' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 500,
          unitLabel: 'Decal'
        },
        {
          id: 'indoor-floor-decals',
          name: 'Indoor Floor Decals',
          image: '/images/step2/Decals_and_Clings/Indoor_Floor_Decals.png',
          materials: [
            { id: 'indoor-floor-decals-semi-gloss-permanent', name: 'Indoor Floor Decals (Semi-Gloss) Permanent' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 50,
          unitLabel: 'Decal'
        },
        {
          id: 'static-clings',
          name: 'Static Clings (white or clear)',
          image: '/images/step2/Decals_and_Clings/Static_Clings_white_or_clear.png',
          materials: [
            { id: 'clear-static-clings-kiss-cut', name: 'Clear (Kiss-Cut) Static Clings - Static (Non-Adh) Glossy' },
            { id: 'white-static-clings-kiss-cut', name: 'White (Kiss-Cut) Static Clings - Static (Non-Adh) Glossy' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 500,
          unitLabel: 'Cling'
        },
        {
          id: 'street-decals',
          name: 'Street Decals',
          image: '/images/step2/Decals_and_Clings/Street_Decals.png',
          materials: [
            { id: 'street-decals-slip-resistant-laminated', name: 'Street Decals (Slip Resistant) Laminated' }
          ],
          quantityType: 'customQuote',
          customQuote: true
        },
        {
          id: 'vinyl-graphics',
          name: 'Vinyl Graphics',
          image: '/images/step2/Decals_and_Clings/Vinyl_Graphics.png',
          materials: [
            { id: 'vinyl-graphics-white-vinyl-removable', name: 'Vinyl Graphics (White Vinyl) Removable' }
          ],
          quantityType: 'customQuote',
          customQuote: true
        },
        {
          id: 'wall-decals',
          name: 'Wall Decals',
          image: '/images/step2/Decals_and_Clings/Wall_Decals.png',
          materials: [
            { id: 'wall-decals-white-vinyl-removable', name: 'Vinyl Graphics (White Vinyl) Removable' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 500,
          unitLabel: 'Decal'
        }
      ]
    },
    {
      id: 'iron-ons',
      name: 'Wearables',
      icon: '👕',
      image: '/images/categories/Wearables/Wearables.png',
      description: 'DTF transfers, patches, and badges',
      subcategories: [
        {
          id: 'classic-tattoos',
          name: 'Classic Tattoos',
          image: '/images/step2/Wearables/Classic_Tattoos.png',
          // 2026-04-24 — moved to quote-only. Legacy materials array left
          // commented for reference should we decide to re-enable online
          // pricing in the future.
          customQuote: true
        },
        {
          id: 'dtf-by-sheet',
          name: 'DTF Heat Transfers (By Sheet)',
          image: '/images/step2/Wearables/DTF_Heat_Transfers_By_Sheet.png',
          materials: [
            { id: 'permanent-image-transfer-dtf', name: 'Permanent Image Transfer Iron-Ons (DTF)' }
          ],
          customQuote: true
        },
        {
          id: 'dtf-heat-transfers',
          name: 'DTF Heat Transfers',
          image: '/images/step2/Wearables/DTF_Heat_Transfers.png',
          materials: [
            { id: 'permanent-image-transfer-dtf', name: 'Permanent Image Transfer Iron-Ons (DTF)' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 500,
          unitLabel: 'Transfer'
        },
        {
          id: 'emblems-patches',
          name: 'Emblems (Patches)',
          image: '/images/step2/Wearables/Emblems_Patches.png',
          materials: [
            { id: 'patches-canvas-matte', name: 'Patches (Canvas) Matte' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 500,
          unitLabel: 'Patch'
        },
        {
          id: 'name-badges',
          name: 'Name Badges',
          image: '/images/step2/Wearables/Name_Badges.png',
          materials: [
            { id: 'name-badges-styrene-matte-magnetic', name: 'Name Badges (Styrene) Matte (Magnetic bar)' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 250,
          unitLabel: 'Badge'
        },
        {
          id: 'tattoo-booklets',
          name: 'Tattoo Booklets',
          image: '/images/step2/Wearables/Tattoo_Booklets.png',
          materials: [
            { id: 'temp-tattoos-kiss-cut', name: 'Temp Tattoos (Kiss-Cut) Removable Clear Matte' },
            { id: 'temp-tattoos-page-multiple', name: 'Temp Tattoos Page (Multiple Designs) Removable Clear Matte' },
            { id: 'temp-tattoos-page-single', name: 'Temp Tattoos Page (Single Design) Removable Clear Matte' }
          ],
          customQuote: true
        }
      ]
    },
    {
      id: 'magnets',
      name: 'Unique Custom Products',
      icon: '🧲',
      image: '/images/categories/Unique_Custom_Products/Unique_Custom_Products.png',
      description: 'Magnets, packing tape, and unique items',
      subcategories: [
        {
          id: 'glow-in-dark',
          name: 'Glow In The Dark',
          image: '/images/step2/Unique_Custom_Products/Glow_In_The_Dark.png',
          materials: [
            { id: 'glow-in-dark-die-cut-permanent', name: 'Glow In The Dark (Die Cut) Glow In The Dark Permanent Stickers' }
          ],
          quantityType: 'individual',
          minQty: 25,
          maxQty: 2000,
          unitLabel: 'Sticker'
        },
        {
          id: 'magnets',
          name: 'Magnets',
          image: '/images/step2/Unique_Custom_Products/Magnets.png',
          materials: [
            { id: 'magnets-20mil-matte-fridge', name: 'Magnets (20mil magnetic material) Matte (Fridge Magnets)' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 2000,
          unitLabel: 'Magnet'
        },
        {
          id: 'multi-ply-labels',
          name: 'Multi-Ply Labels',
          image: '/images/step2/Unique_Custom_Products/Multi-Ply_Labels.png',
          customQuote: true
        },
        {
          id: 'packing-tape',
          name: 'Packing Tape',
          image: '/images/step2/Unique_Custom_Products/Packing_Tape.png',
          customQuote: true
        },
        {
          id: 'uv-dtf-stickers',
          name: 'UV DTF Stickers',
          image: '/images/step2/Unique_Custom_Products/UV_DTF_Stickers.png',
          materials: [
            { id: 'uv-dtf-permanent-stickers', name: 'UV DTF Permanent Stickers' }
          ],
          quantityType: 'individual',
          minQty: 10,
          maxQty: 1000,
          unitLabel: 'DTF Sticker'
        },
        {
          id: 'vehicle-magnets',
          name: 'Vehicle Magnets',
          image: '/images/step2/Unique_Custom_Products/Vehicle_Magnets.png',
          materials: [
            { id: 'magnets-30mil-matte-vehicle', name: 'Magnets (30mil magnetic material) Matte (Vehicle Magnets)' }
          ],
          quantityType: 'individual',
          minQty: 1,
          maxQty: 2000,
          unitLabel: 'Magnet'
        }
      ]
    },
    {
      id: 'specialty',
      name: 'Specialty Niche Products',
      icon: '✨',
      image: '/images/categories/Specialty_Niche_Products/Specialty_Niche_Products.png',
      description: 'Embossing, hot stamping, and specialty finishes',
      subcategories: [
        {
          id: 'back-print',
          name: 'Back Print',
          image: '/images/step2/Specialty_Niche_Products/Back_Print.png',
          customQuote: true
        },
        {
          id: 'colour-changing-ink',
          name: 'Colour Changing Ink',
          image: '/images/step2/Specialty_Niche_Products/Colour_Changing_Ink.png',
          customQuote: true
        },
        {
          id: 'embossing',
          name: 'Embossing',
          image: '/images/step2/Specialty_Niche_Products/Embossing.png',
          customQuote: true
        },
        {
          id: 'hot-stamping',
          name: 'Hot Stamping',
          image: '/images/step2/Specialty_Niche_Products/Hot_Stamping.png',
          customQuote: true
        },
        {
          id: 'scratch-n-sniff',
          name: "Scratch 'N Sniff",
          image: '/images/step2/Specialty_Niche_Products/Scratch_N_Sniff.png',
          customQuote: true
        },
        {
          id: 'silkscreen-effects',
          name: 'Silkscreen Effects',
          image: '/images/step2/Specialty_Niche_Products/Silkscreen_Effects.png',
          customQuote: true
        }
      ]
    }
  ],
  // Quantities for page-based products
  quantitiesPages: [
    { qty: 20, pages: 1, discount: 0 },
    { qty: 40, pages: 2, discount: 13 },
    { qty: 60, pages: 3, discount: 25 },
    { qty: 80, pages: 4, discount: 26 },
    { qty: 100, pages: 5, discount: 28 },
    { qty: 160, pages: 8, discount: 41 },
    { qty: 200, pages: 10, discount: 50 },
    { qty: 500, pages: 25, discount: 67 },
    { qty: 1000, pages: 50, discount: 70 },
    { qty: 1500, pages: 75, discount: 71 },
    { qty: 2000, pages: 100, discount: 74 },
    { qty: 2500, pages: 125, discount: 74 },
    { qty: 3000, pages: 150, discount: 75 },
    { qty: 5000, pages: 250, discount: 75 },
    { qty: 10000, pages: 500, discount: 75 }
  ],

  // Quantities for individual items (die-cuts, kiss-cuts, decals, clings)
  // Based on PromotedYou actual pricing, then 25% cheaper
  quantitiesIndividual: [
    { qty: 1, discount: 0, promotedYouPrice: 7.21 },
    { qty: 5, discount: 43, promotedYouPrice: 20.59 },
    { qty: 10, discount: 68, promotedYouPrice: 23.16 },
    { qty: 25, discount: 74, promotedYouPrice: 47.16 },
    { qty: 50, discount: 79, promotedYouPrice: 74.03 },
    { qty: 100, discount: 86, promotedYouPrice: 102.63 },
    { qty: 250, discount: 90, promotedYouPrice: 187.14 },
    { qty: 500, discount: 92, promotedYouPrice: 336.11 },
    { qty: 1000, discount: 94, promotedYouPrice: 588.77 },
    { qty: 2500, discount: 95, promotedYouPrice: 1338.69 },
    { qty: 5000, discount: 96, promotedYouPrice: 2466.42 },
    { qty: 10000, discount: 97, promotedYouPrice: 4567.88 }
  ],

  currencyRates: {
    USD: 1.0,
    CAD: 1.37  // 1 USD = 1.37 CAD (approximate rate)
  }
};
